import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {FormBuilder, FormControl, FormGroup} from '@angular/forms';
import {TipoCodigoDTO} from '../../../../models/dtos/TipoCodigoDTO';
import {DetalleTipoCodigoDTO} from '../../../../models/dtos/DetalleTipoCodigoDTO';
import {Utils} from '../../../utils/utils';

@Component({
  selector: 'app-detalle-tipo-codigo',
  templateUrl: './detalle-tipo-codigo.component.html',
  styleUrls: ['./detalle-tipo-codigo.component.scss']
})
export class DetalleTipoCodigoComponent implements OnInit {

  @Input()
  tipCodigos: TipoCodigoDTO[] = [];

  @Input()
  tiposInsertados: DetalleTipoCodigoDTO[] = [];

  @Input()
  selectedTipoCodigo: number;

  @Input()
  codigo: string = '';

  @Input()
  posicion: number;

  @Output()
  removeComponent: EventEmitter<boolean> = new EventEmitter<boolean>();

  @Output()
  tiposInsertadosChanged: EventEmitter<DetalleTipoCodigoDTO[]> = new EventEmitter<DetalleTipoCodigoDTO[]>();

  tipoCodigoFormGroup: FormGroup;

  constructor() {
  }

  ngOnInit() {
    this.tipoCodigoFormGroup = new FormGroup({
      tipoCodigoControl: new FormControl(this.selectedTipoCodigo, []),
      tipoCodigoDescripcionControl: new FormControl(this.codigo, [this.customValidator.bind(this)]),
    });
  }

  customValidator(control: FormControl) {
    const isValid = this.validateInput(control.value);
    return isValid ? null : {customError: true};
  }

  existTipoCodigo(codigo: any) {
    return this.tiposInsertados.some(tipoCodigo => codigo === tipoCodigo.tipoCodigo);
  }

  removeTipoCodigo() {
    this.removeComponent.emit(true);
  }

  onListItemSelectionChange() {
    this.tiposInsertados[this.posicion].tipoCodigo = this.tipoCodigoFormGroup.get('tipoCodigoControl').value;
    this.tiposInsertados[this.posicion].value = this.tipCodigos.find(tipCodigo => tipCodigo.codigo === this.tipoCodigoFormGroup.get('tipoCodigoControl').value).descripcion;
    this.tipoCodigoFormGroup.get('tipoCodigoDescripcionControl').updateValueAndValidity();
    this.emitEvent();
  }

  onInputChange(): void {
    if (this.tiposInsertados[this.posicion].value !== 'EAN' || (this.tiposInsertados[this.posicion].value === 'EAN' && Utils.esCodigoGTINValido(this.tipoCodigoFormGroup.get('tipoCodigoDescripcionControl').value))) {
      this.tiposInsertados[this.posicion].codigo = this.tipoCodigoFormGroup.get('tipoCodigoDescripcionControl').value;
      this.emitEvent();
    }
  }

  emitEvent() {
    this.tiposInsertadosChanged.emit(this.tiposInsertados);
  }

  validateInput(value: string) {
    const state: boolean = !(this.tiposInsertados[this.posicion].value === 'EAN' && !Utils.esCodigoGTINValido(value));
    state ? this.tiposInsertados[this.posicion].numero = 0 : this.tiposInsertados[this.posicion].numero = 1;
    this.emitEvent();
    return state;
  }

}
